import { hot } from 'react-hot-loader';
import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import { Router } from './router';
import { RevoluTransferProvider } from './context';
import { DatePickerProvider } from './components/datePicketProvider';



let theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      light: '#7199de',
      main: '#3d6bac',
      dark: '#00417c',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#ffda64',
      main: '#f4a932',
      dark: '#bd7a00',
      contrastText: '#000000',
    },
  },
});
theme = responsiveFontSizes(theme);

const App = () => (
  <React.Fragment>
    <DatePickerProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RevoluTransferProvider>
            <Router />
          </RevoluTransferProvider>
        </ThemeProvider>
    </DatePickerProvider >
  </React.Fragment>
)

export default hot(module)(App);
